<template>
  <div class="prodotti-page">

    <div class="cards-container">

      <!-- Questo codice creerà una nuova card per ogni elemento all'interno della lista prodotti
       che sti trova all'interno dello script -->
      <div 
        v-for="(prodotto, index) in prodotti" 
        :key="index" 
        :class="['card', index % 2 === 0 ? 'pari' : 'dispari']"
      >
        <img :src="prodotto.foto" alt="prodotto.image" />
        <h3>{{ prodotto.titolo }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginaProdotti",
  data() {
    return {
      prodotti: [
        { titolo: "Convertitore Strain-Gauge a can-bus", foto: require('@/assets/AMPc.jpeg') },
        { titolo: "Convertitore Strain-Gauge a 4-20mA", foto: require('@/assets/AMPc2.jpeg') },
        { titolo: "Convertitore 4-20mA a can-bus", foto: require('@/assets/AMPc3.jpeg') },
        { titolo: "Sensore angolare a stato solido", foto: require('@/assets/AS360.jpeg') },
        { titolo: "Blocco di sicurezza angolo per cestelli a gravita’", foto: require('@/assets/Blocco_angolo.jpeg') },
        { titolo: "Sensore di inclinazione per applicazioni di sicurezza", foto: require('@/assets/CPS.jpeg') },
        { titolo: "Unita' di diagnostica remota con geolocalizzazione GPS/GNSS", foto: require('@/assets/FM3.jpeg') },
        { titolo: "Unita' di diagnostica e geolocalizzazione remota tramite portale gestionale", foto: require('@/assets/FM4.jpeg') },
        { titolo: "Level Basket", foto: require('@/assets/LB_V4.jpeg') },
        { titolo: "Livellamento automatico del cesto servo-assistito", foto: require('@/assets/LIV_SA.jpeg') },
        { titolo: "Unita’ di controllo elettronico per applicazioni di sicurezza", foto: require('@/assets/MU2S.jpeg') },
        { titolo: "Unita’ programmabile automotive", foto: require('@/assets/MU0RS.jpeg') },
        { titolo: "AUTOMOTIVE PROGRAMMABLE RUGGED UNIT FOR SAFETY APPLICATIONS", foto: require('@/assets/MU2RS.jpeg') }

        // aggiungi qui altri prodotti
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

//Qui indico le dimensioni della pagina prodotti
.prodotti-page {
  padding: 0 5vw;
  box-sizing: border-box;
  width: 100vw;

  
  .cards-container {

    //Questo codice serve a indicare come disporre i vari prodotti all'interno del contenitore
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 3rem;
    margin-top: 10vh;

    .card {
      //Questo è lo stile di ogni card
      padding-top: 2%;
      width: 20vw;
      text-align: center;
      overflow: hidden;

      //per effetto hover
      img {
        width: 85%;
        margin: auto;
        height: auto;
        display: block;
      }
      
      h3 {
        padding: 1rem;
      }
      
      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);
      }
      transition: 
        transform 0.5s ease,
        box-shadow 0.5s ease;
    }

    .pari {
      background-color: $tcan_orange;
      color: white;
    }

    .dispari {
      background-color: $tcan_green;
      color: white;
    }
  }
}

@media screen and (max-width: 768px) {

  .prodotti-page {
    .cards-container {
      flex-direction: column;
      .card {
        width: 90vw;
      }
    }
  }
}
</style>
